import { render, staticRenderFns } from "./FormModelForm.vue?vue&type=template&id=d1309152&"
import script from "./FormModelForm.vue?vue&type=script&lang=ts&"
export * from "./FormModelForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports